import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Topbar from '../components/Header/Topbar';
import Header from '../components/Header/Navbar';
import Footer from '../components/Footer/Footer';
import Spinner from '../components/Spinner/Spinner';
import SEO from '../components/SEO/SEO';
import '../styles/SingleProduct.css';

const SingleProduct = () => {
  const { productId } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [activeTab, setActiveTab] = useState('description');
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reviewResult, setReviewResult] = useState("");

  useEffect(() => {
    // Get product data from localStorage
    const productData = localStorage.getItem('currentProduct');
    
    if (productData) {
      const parsedProduct = JSON.parse(productData);
      setProduct(parsedProduct);
      
      // Generate related products
      generateRelatedProducts(parsedProduct);
    } else {
      // If no product data, redirect to home
      navigate('/');
    }
    
    setLoading(false);
    
    // Initialize WOW.js animations
    if (window.WOW) {
      new window.WOW().init();
    }
  }, [productId, navigate]);

  const generateRelatedProducts = (currentProduct) => {
    // Generate related products based on current product
    const related = [
      {
        id: 'related-1',
        name: `${currentProduct.brand || 'EXIDE'} Premium Series`,
        image: currentProduct.image,
        // price: '₹5,999',
        // oldPrice: '₹6,999'
      },
      {
        id: 'related-2',
        name: `${currentProduct.brand || 'EXIDE'} Advanced Series`,
        image: currentProduct.image,
        // price: '₹6,499',
        // oldPrice: '₹7,499'
      },
      {
        id: 'related-3',
        name: `${currentProduct.brand || 'EXIDE'} Professional Series`,
        image: currentProduct.image,
        // price: '₹7,999',
        // oldPrice: '₹8,999'
      },
      {
        id: 'related-4',
        name: `${currentProduct.brand || 'EXIDE'} Ultimate Series`,
        image: currentProduct.image,
        // price: '₹8,999',
        // oldPrice: '₹9,999'
      }
    ];
    
    setRelatedProducts(related);
  };

  const handleQuantityChange = (type) => {
    if (type === 'increment') {
      setQuantity(prev => prev + 1);
    } else if (type === 'decrement' && quantity > 1) {
      setQuantity(prev => prev - 1);
    }
  };

  const handleCallNow = () => {
  window.location.href = 'tel:+919865757472';
};


const handleWhatsAppNow = () => {
  const phoneNumber = '919865757472';
  const message = `Hello, I'm interested in ${product.name}. Can you provide more details?`;
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  window.open(whatsappUrl, '_blank');
};

  const handleRelatedProductClick = (relatedProduct) => {
    // Create new product data object
    const productData = {
      id: relatedProduct.id,
      name: relatedProduct.name,
      image: relatedProduct.image,
      brand: product.brand,
      category: product.category,
      categoryId: product.categoryId,
      specifications: product.specifications,
      description: product.description,
      warranty: product.warranty
    };

    // Store in localStorage
    localStorage.setItem('currentProduct', JSON.stringify(productData));
    
    // Reload the page with new product
    window.location.href = `/product/${encodeURIComponent(relatedProduct.id)}`;
  };

  const onReviewSubmit = async (event) => {
    event.preventDefault();
    setReviewResult("Sending....");
    const formData = new FormData(event.target);
    formData.append("access_key", "387201d8-87b2-4ce9-9a44-7ed27cbcbff1");
    formData.append("product_name", product.name);
    formData.append("product_brand", product.brand);

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();
    if (data.success) {
      setReviewResult("Review Submitted Successfully");
      event.target.reset();
      setTimeout(() => setReviewResult(""), 5000); // Clear message after 5 seconds
    } else {
      setReviewResult("Error submitting review. Please try again.");
    }
  };

  // Helper function to extract battery capacity from product name
  const getBatteryCapacity = () => {
    if (!product || !product.name) return 'N/A';
    
    // Try to extract capacity from product name
    const capacityMatch = product.name.match(/(\d+(\.\d+)?)\s*(Ah|AH|ah)/i);
    if (capacityMatch) {
      return `${capacityMatch[1]} Ah`;
    }
    
    // Default capacities based on product category
    if (product.categoryId === 'motor-cycle' || product.category === 'Motor Cycle Batteries') {
      return '2.5-12 Ah';
    } else if (product.categoryId === 'car' || product.category === 'Car Batteries') {
      return '35-105 Ah';
    } else if (product.categoryId === 'heavy-vehicles' || product.category === 'Heavy Vehicle Batteries') {
      return '100-200 Ah';
    } else if (product.categoryId === 'invamaster' || product.categoryId === 'invatubular' || 
               product.categoryId === 'inverter-batteries' || product.category === 'Inverter Batteries') {
      return '75-260 Ah';
    } else if (product.categoryId === 'solar' || product.category === 'Solar Batteries') {
      return '20-200 Ah';
    }
    
    return 'N/A';
  };

  // Get updated specifications with Battery Capacity instead of Voltage
  const getUpdatedSpecifications = () => {
    if (!product || !product.specifications) return {};
    
    const updatedSpecs = { ...product.specifications };
    
    // Remove Voltage and add Battery Capacity
    delete updatedSpecs.Voltage;
    delete updatedSpecs.voltage;
    
    const batteryCapacity = getBatteryCapacity();
    updatedSpecs['Battery Capacity'] = batteryCapacity;
    
    return updatedSpecs;
  };

  if (loading) {
    return <Spinner />;
  }

  if (!product) {
    return (
      <div className="single-product-container">
        <Topbar />
        <Header />
        <div className="container py-5">
          <div className="alert alert-warning text-center">
            <h4>Product not found</h4>
            <p>The product you're looking for doesn't exist or has been removed.</p>
            <button 
              className="btn btn-primary" 
              onClick={() => navigate('/')}
              style={{ backgroundColor: '#DE400E', borderColor: '#DE400E' }}
            >
              Go to Homepage
            </button>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  const updatedSpecifications = getUpdatedSpecifications();

  return (
    <div className="single-product-container">
      <SEO 
        title={product.name}
        description={product.description || `Buy ${product.name} - ${product.brand} ${product.category}. High-quality power solution from Galaxy Power System, Chidambaram.`}
        keywords={`${product.name}, ${product.brand} battery, ${product.category}, galaxy power system`}
        canonicalUrl={`https://galaxypowersystems.com/product/${productId}`}
        ogImage={product.image}
        pageType="product"
        product={product}
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'Products', url: '/#products' },
          { name: product.name, url: `/product/${productId}` }
        ]}
      />
      <Topbar />
      <Header />
      
      {/* Single Page Header */}
      <div className="container-fluid page-header py-5" style={{ backgroundColor: '#DE400E' }}>
        <div className="container">
          <h1 className="text-center text-white display-6 wow fadeInUp" data-wow-delay="0.1s">
            {product.name}
          </h1>
          <ol className="breadcrumb justify-content-center mb-0 wow fadeInUp" data-wow-delay="0.3s">
            <li className="breadcrumb-item">
              <a href="/" className="text-white text-decoration-none">Home</a>
            </li>
            <li className="breadcrumb-item">
              <a href="/#products" className="text-white text-decoration-none">Products</a>
            </li>
            <li className="breadcrumb-item active text-white">
              {product.brand} - {product.category}
            </li>
          </ol>
        </div>
      </div>

      {/* Single Products Start - Full Width */}
      <div className="container-fluid shop py-5 px-0">
        <div className="container px-0">
          <div className="row g-0">
            {/* Main Product Content - Full Width */}
            <div className="col-12 wow fadeInUp" data-wow-delay="0.1s">
              <div className="row g-0 single-product">
                {/* Product Images and Details */}
                <div className="col-lg-6 px-4 px-lg-5">
                  <div className="single-inner bg-light rounded mb-4">
                    <img 
                      src={product.image} 
                      className="img-fluid rounded w-100" 
                      alt={product.name} 
                      style={{ maxHeight: '400px', objectFit: 'contain' }}
                    />
                  </div>
                </div>

                {/* Product Details */}
                <div className="col-lg-6 px-4 px-lg-5">
                  <h2 className="fw-bold mb-3">{product.name}</h2>
                  <p className="mb-3">Brand: <strong style={{ color: '#DE400E' }}>{product.brand?.toUpperCase() || 'EXIDE'}</strong></p>
                  <p className="mb-3">Category: <strong>{product.category || 'Battery'}</strong></p>
                  
                  {/* Specifications */}
                  <div className="mb-4">
                    <h5 className="fw-bold mb-3">Specifications:</h5>
                    <ul className="list-unstyled">
                      {Object.entries(updatedSpecifications).map(([key, value]) => (
                        <li key={key} className="mb-2">
                          <strong>{key}:</strong> {value}
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Warranty */}
                  <div className="mb-4">
                    <h6 className="fw-bold">Warranty:</h6>
                    <p className="text-success">{product.warranty || 'Standard warranty applies'}</p>
                  </div>

                  {/* Quantity Selector - Removed as per requirement */}
                  
                  {/* Action Buttons - Call Now & WhatsApp Now */}
                  <div className="d-flex flex-wrap gap-3 mb-4">
                    <button 
                      className="btn btn-primary rounded-pill px-4 py-2 flex-grow-1"
                      onClick={handleCallNow}
                      style={{ backgroundColor: '#DE400E', borderColor: '#DE400E', minWidth: '150px' }}
                    >
                      <i className="fa fa-phone me-2"></i> Call Now
                    </button>
                    <button 
                      className="btn btn-success rounded-pill px-4 py-2 flex-grow-1"
                      onClick={handleWhatsAppNow}
                      style={{ backgroundColor: '#25D366', borderColor: '#25D366', minWidth: '150px' }}
                    >
                      <i className="fab fa-whatsapp me-2"></i> WhatsApp Now
                    </button>
                  </div>

                  {/* Share Buttons */}
                  <div className="mb-4">
                    <h6 className="fw-bold mb-2">Share this product:</h6>
                    <div className="d-flex gap-2">
                      <button className="btn btn-primary d-inline-block rounded text-white py-1 px-3">
                        <i className="fab fa-facebook-f me-1"></i> Share
                      </button>
                      <button className="btn btn-secondary d-inline-block rounded text-white py-1 px-3">
                        <i className="fab fa-twitter me-1"></i> Tweet
                      </button>
                    </div>
                  </div>
                </div>

                {/* Product Tabs - Full Width */}
                <div className="col-12 mt-5 px-4 px-lg-5">
                  <nav>
                    <div className="nav nav-tabs mb-3">
                      <button 
                        className={`nav-link ${activeTab === 'description' ? 'active' : ''}`}
                        onClick={() => setActiveTab('description')}
                      >
                        Description
                      </button>
                      <button 
                        className={`nav-link ${activeTab === 'specifications' ? 'active' : ''}`}
                        onClick={() => setActiveTab('specifications')}
                      >
                        Specifications
                      </button>
                      <button 
                        className={`nav-link ${activeTab === 'reviews' ? 'active' : ''}`}
                        onClick={() => setActiveTab('reviews')}
                      >
                        Reviews
                      </button>
                    </div>
                  </nav>

                  <div className="tab-content">
                    {/* Description Tab */}
                    <div className={`tab-pane fade ${activeTab === 'description' ? 'show active' : ''}`}>
                      <p>{product.description}</p>
                      <p className="mb-4">The {product.name} is engineered with cutting-edge technology to deliver superior performance and reliability. Built with advanced features for enhanced durability and longer service life, making it the perfect choice for your power needs.</p>
                      
                      <h5 className="fw-bold">Key Features:</h5>
                      <ul>
                        <li>Longer service life with advanced technology</li>
                        <li>Low maintenance design</li>
                        <li>Excellent deep discharge recovery</li>
                        <li>Superior charge acceptance</li>
                        <li>High vibration resistance</li>
                        <li>Leak-proof construction</li>
                      </ul>
                    </div>

                    {/* Specifications Tab */}
                    <div className={`tab-pane fade ${activeTab === 'specifications' ? 'show active' : ''}`}>
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <tbody>
                            {Object.entries(updatedSpecifications).map(([key, value]) => (
                              <tr key={key}>
                                <th style={{ width: '40%' }}>{key}</th>
                                <td>{value}</td>
                              </tr>
                            ))}
                            <tr>
                              <th>Brand</th>
                              <td>{product.brand?.toUpperCase() || 'EXIDE'}</td>
                            </tr>
                            <tr>
                              <th>Category</th>
                              <td>{product.category || 'Battery'}</td>
                            </tr>
                            <tr>
                              <th>Warranty</th>
                              <td>{product.warranty || 'Standard warranty'}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {/* Reviews Tab */}
                    <div className={`tab-pane fade ${activeTab === 'reviews' ? 'show active' : ''}`}>
                      <div className="mb-4">
                        <h5 className="fw-bold mb-3">Customer Reviews</h5>
                        <div className="d-flex align-items-center mb-3">
                          <div className="d-flex me-3">
                            {[1, 2, 3, 4, 5].map((star) => (
                              <i key={star} className="fa fa-star text-warning"></i>
                            ))}
                          </div>
                          <span>4.5 out of 5 stars</span>
                        </div>
                      </div>

                      {/* Review Form */}
                      <form onSubmit={onReviewSubmit}>
                        <h5 className="fw-bold mb-3">Write a Review</h5>
                        <div className="row g-3">
                          <div className="col-md-6">
                            <input type="text" className="form-control" name="name" placeholder="Your Name" required />
                          </div>
                          <div className="col-md-6">
                            <input type="email" className="form-control" name="email" placeholder="Your Email" required />
                          </div>
                          <div className="col-12">
                            <textarea className="form-control" rows="4" name="message" placeholder="Your Review" required></textarea>
                          </div>
                          <div className="col-12">
                            <button type="submit" className="btn btn-primary">Submit Review</button>
                          </div>
                          {reviewResult && <div className="col-12"><span className="text-success">{reviewResult}</span></div>}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Related Products */}
      <div className="container-fluid related-product py-5">
        <div className="container">
          <div className="mx-auto text-center pb-5" style={{ maxWidth: '700px' }}>
            <h4 className="mb-4 d-inline-block p-2">Related Products</h4>
            <p>Check out these similar products that might interest you</p>
          </div>
          
          <div className="row g-4">
            {relatedProducts.map((related) => (
              <div key={related.id} className="col-lg-3 col-md-6">
                <div className="card h-100 border-0 shadow-sm">
                  <div className="position-relative">
                    <img src={related.image} className="card-img-top" alt={related.name} />
                    <div className="position-absolute top-0 end-0 m-2">
                      <span className="badge bg-danger">New</span>
                    </div>
                  </div>
                  <div className="card-body text-center">
                    <h5 className="card-title">{related.name}</h5>
                    <div className="d-flex justify-content-center align-items-center mb-2">
                      <span className="text-danger fw-bold fs-5">{related.price}</span>
                      <del className="text-muted ms-2">{related.oldPrice}</del>
                    </div>
                    <button 
                      className="btn btn-primary btn-sm"
                      onClick={() => handleRelatedProductClick(related)}
                      style={{ backgroundColor: '#DE400E', borderColor: '#DE400E' }}
                    >
                      <i className="fa fa-eye me-1"></i> View Details
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default SingleProduct;